"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function FilterCondition(_ref) {
  var FieldComponent = _ref.FieldComponent,
      FieldComponentProps = _ref.FieldComponentProps,
      mode = _ref.mode,
      ValueComponent = _ref.ValueComponent,
      ValueComponentProps = _ref.ValueComponentProps;

  if (mode === 'field') {
    return /*#__PURE__*/_react.default.createElement(FieldComponent, FieldComponentProps);
  }

  if (mode === 'value' && ValueComponent) {
    return /*#__PURE__*/_react.default.createElement(ValueComponent, ValueComponentProps);
  }

  return null;
}

process.env.NODE_ENV !== "production" ? FilterCondition.propTypes = {
  FieldComponent: _propTypes.default.elementType.isRequired,
  FieldComponentProps: _propTypes.default.shape({}),
  mode: _propTypes.default.oneOf(['field', 'value']),
  ValueComponent: _propTypes.default.elementType,
  ValueComponentProps: _propTypes.default.shape({})
} : void 0;
FilterCondition.defaultProps = {
  FieldComponentProps: undefined,
  mode: 'field',
  ValueComponent: undefined,
  ValueComponentProps: undefined
};
var _default = FilterCondition;
exports.default = _default;